import axios from '@/api/requests/axios'

export default {
  clear: () => axios.put('/api/admin/v1/cashes'),
}
